import { Button } from '@/components/common';
import Icons from '@/const/icons';
import { usePermissions } from '@/context/PermissionsContext';
import clsx from 'clsx';
import * as React from 'react';

interface ButtonsFormProps {
	onClickPreview: () => void;
	onClickSave?: () => void;
	onClickComplete?: () => void;
	isCompleted?: boolean;
	isApproved?: boolean;
	isPreviewDisabled?: boolean;
	isSaveDisabled?: boolean;
	isCompleteDisabled?: boolean;
	saveButtonClassName?: string;
	completeButtonClassName?: string;
	customButton?: React.ReactNode;
	onlyOneButton?: boolean;
	buttonTitle?: string;
}

export const ButtonsForm: React.FC<ButtonsFormProps> = ({
	onClickComplete,
	onClickPreview,
	onClickSave,
	isCompleted,
	isCompleteDisabled,
	isPreviewDisabled,
	isSaveDisabled,
	saveButtonClassName,
	completeButtonClassName,
	customButton,
	onlyOneButton,
	isApproved,
	buttonTitle,
}) => {
	const { allowed } = usePermissions();
	const hasPermission = allowed.has('case_admin');

	const labelButton = isApproved ? 'View Preview' : 'Preview and Approve';

	return (
		<div className="flex items-center justify-start w-full gap-x-8 mt-2">
			{customButton && customButton}
			{onlyOneButton ? (
				<Button
					label={buttonTitle ? buttonTitle : labelButton}
					decoration="line-primary"
					size="medium"
					onClick={onClickPreview}
					iconRight={isCompleted}
					icon={Icons.checkWhite}
					disabled={isCompleteDisabled}
					className={clsx('h-[30px]', completeButtonClassName)}
					classNameButton="!size-4"
				/>
			) : (
				<>
					<Button
						label="Preview"
						decoration="line-primary"
						size="medium"
						onClick={onClickPreview}
						disabled={isPreviewDisabled}
					/>
					{onClickSave && (
						<Button
							label="Save"
							decoration="line-primary"
							size="medium"
							onClick={onClickSave}
							disabled={!hasPermission} // this was commented out due to Amira's request on ticket CMEBF-241
							className={saveButtonClassName}
						/>
					)}
					{isSaveDisabled !== undefined && void 0}{' '}
					{/* this is added to keep the isSaveDisabled and not have it unused  */}
					{/* Ensures no unused var warning*/}
					<Button
						label="Complete"
						decoration="primary"
						size="medium"
						onClick={onClickComplete}
						iconRight={isCompleted}
						icon={Icons.checkWhite}
						disabled={isCompleteDisabled}
						className={completeButtonClassName || ''}
						classNameButton="!size-4"
					/>
				</>
			)}
		</div>
	);
};
